import axios from '@axios';
import _ from 'underscore';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchProducts(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/products', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchProduct(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/product/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        changeProductStatus(ctx, { id, status }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/product/${id}/change-status`, { status })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteProduct(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/product/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}